import React, { useEffect } from "react";
import {useNavigate, useParams} from "react-router-dom";
import useTranslate from "../../hooks/useTranslate";
import Navbar from "./components/Navbar";
import {useSelector} from "react-redux";
import ICombinedState from "../../redux/model/ICombinedState";
import {useLocalStorage} from "../../hooks/useLocalStorage";
import {LANDING, REGISTER, TRIPS} from "../../constants/ROUTER_PATH_TITLE";
import DiscoverPageMain from "./components/DiscoverPageMain";
import Footer from "./components/Footer";
import FeaturedDestinations from "./components/FeaturedDestinations";
import FeaturedItineraries from "./components/FeaturedItineraries";
import {info} from "sass";
const DiscoverPage = () => {
    const { language } = useParams();
    const formattedLanguage = language
        ? language.toUpperCase() === "PT-BR"
            ? "pt-BR"
            : language.split("-")[0].toLowerCase()
        : undefined;

    const { t, onSelectedLangCode, langCode } = useTranslate();
    useEffect(() => {
        const langCodeKeys: string[] = window.tconfig.T.langCodes.map(l => l.value);

        if (formattedLanguage && langCodeKeys.includes(formattedLanguage)) {
            onSelectedLangCode(formattedLanguage);
        }
    }, [formattedLanguage, onSelectedLangCode]);

    const isLoggedIn = useSelector(
        (state: ICombinedState) => state.user.isLoggedIn
    );

    const { getLocalData } = useLocalStorage<"light" | "dark">("theme");
    const theme = getLocalData();

    const navigate = useNavigate();

    document.title = LANDING.TITLE(t("valai.discover"));

    const onClickSignUp = () => {
        if (isLoggedIn) {
            navigate(TRIPS.PATH);
        } else {
            if (window.tconfig.SHOW_REGISTER) {
                navigate(REGISTER.PATH);
            }
        }
    };

    return (
        <>
            <div className="min-h-screen font-geist text-[#0B1215]">
                <Navbar
                    theme={theme}
                    t={t}
                />
                <main>
                    <DiscoverPageMain
                    title="City"
                    />
                    <FeaturedDestinations />
                    <FeaturedItineraries />
                </main>
                <Footer t={t} />
            </div>
        </>
    );
}

export default DiscoverPage;